import { ElementRef, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AssetsGenerateUrlService, AssetUIModel } from '@thehubz/client/core';
import { CreateAssetDto } from '@thehubz/client/data-access-api';
import { AnyType } from '@thehubz/shared/model';
import { AssetFullScreenComponent } from './asset-full-screen.component';

export interface AssetFullScreenItem {
  kind: 'asset' | 'taskAsset';
  asset: AssetUIModel;
  version?: number;
  externalUserFlag?: boolean;
}

/**
 * Use this service to open the asset in full screen.
 * We use this service because it has no dependency to AssetFullScreenComponent.
 */
@Injectable({ providedIn: 'root' })
export class AssetFullScreen {
  dialogRef!: MatDialogRef<AssetFullScreenComponent>;
  bannerImgHidden = false;
  assetTypes = CreateAssetDto.AssetTypeEnum;

  constructor(private dialog: MatDialog, private assetUrlService: AssetsGenerateUrlService) {}

  openAsset(asset: AssetUIModel, version?: number) {
    if (version) {
      asset = this.assetUrlService.addPreviewUrl(asset, version);
      this.assetFullScreen(asset);
    } else {
      this.assetFullScreen(asset);
    }
  }

  openTaskAsset(asset: AssetUIModel, externalUserFlag: boolean) {
    const WIDTH = '90%';
    this.dialog.open(AssetFullScreenComponent, {
      width: WIDTH,
      maxWidth: '100vw',
      disableClose: true,
      data: { ...asset, viewHeader: true, externalUserFlag },
    });
  }

  openVideo(videoContainer: ElementRef<AnyType>) {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else if (videoContainer.nativeElement.webkitRequestFullscreen) {
      // Need this to support Safari
      videoContainer.nativeElement.webkitRequestFullscreen();
    } else {
      videoContainer.nativeElement.requestFullscreen();
    }
  }

  private assetFullScreen(assetData: AssetUIModel) {
    const WIDTH = '90%';
    this.dialog.open(AssetFullScreenComponent, {
      width: WIDTH,
      maxWidth: '100vw',
      disableClose: true,
      data: { ...assetData, bannerHtmlHidden: this.bannerImgHidden },
    });
  }
}
